import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	standalone: false,
	selector: 'pmc-request-access-confirmation',
	templateUrl: './confirmation.component.html'
})
export class RequestAccessConfirmationComponent implements OnInit {
	/** The case number shown to the user. Set from the route param or the wizard finish response. */
	requestId = '';

	/**
	 * True when the user arrived via the wizard finish path (/confirmation/submitted).
	 * In this case no specific case number is available yet (email will contain it).
	 */
	isWizardSubmit = false;

	constructor(
		private route: ActivatedRoute,
		private router: Router
	) {
	}

	ngOnInit(): void {
		const id = this.route.snapshot.params['id'] || '';
		if (id === 'submitted') {
			// Arrived from wizard finish — no numeric ID available client-side yet
			this.isWizardSubmit = true;
			this.requestId      = '';
		} else {
			this.requestId = id || 'UNKNOWN';
		}
	}

	goToLogin(): void {
		this.router.navigate(['/login']);
	}

	printConfirmation(): void {
		window.print();
	}
}